var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"px-5 mt-2"},[_c('v-btn',{staticClass:"mr-4",attrs:{"color":"blue","to":{ name: 'SystemSettingsProducts' }}},[_vm._v("Zpět")])],1),_c('div')])}
var staticRenderFns = []

export { render, staticRenderFns }